import DevicesList from '../components/DevicesList/DevicesList';

export default function Devices() {

    return(
     <DevicesList />
    )
}
